import React, { useEffect } from 'react';

const SuccessNotification = ({ message, onClose, duration = 3000, type = "success" }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const typeStyles = {
    success: {
      bg: "bg-green-900/90",
      border: "border-green-500",
      icon: "✓"
    },
    error: {
      bg: "bg-red-900/90",
      border: "border-red-500",
      icon: "✗"
    },
    info: {
      bg: "bg-blue-900/90",
      border: "border-blue-500",
      icon: "ℹ"
    }
  };

  const style = typeStyles[type] || typeStyles.success;

  return (
    <div className="fixed top-4 right-4 z-[10000] animate-slide-in">
      <div className={`${style.bg} ${style.border} border-2 rounded-lg shadow-2xl p-4 min-w-[300px] max-w-md backdrop-blur-sm`}>
        <div className="flex items-center gap-3">
          <div className="text-2xl">{style.icon}</div>
          <p className="text-white font-medium flex-1">{message}</p>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            ✕
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessNotification;
